export default "__VITE_ASSET__9ece931c__"